export const downloadBase64File = (base64Data: string, fileName: string) => {
  const a = document.createElement("a")
  document.body.appendChild(a)
  a.href = base64Data
  a.download = fileName
  a.click()
  a.remove()
}
